import { Controller } from "@hotwired/stimulus"
import { geoMercator } from "d3-geo"
import { MAP_WIDTH, MAP_HEIGHT, MAINLAND_CENTER, MAINLAND_SCALE, OKINAWA_CENTER } from "../lib/japan_map_projections"

const NS = "http://www.w3.org/2000/svg"
const OKINAWA_CODE = "47"

// 点描の日本地図 (BengoshiMap::DotMapComponent) に所在地のピンを立て、ホバーした弁護士のピンを目立たせる
export default class extends Controller {
  static targets = ["svg", "caption"]

  connect() {
    const { okinawaScale, okinawaTx, okinawaTy, pins } = this.svgTarget.dataset
    this.mainland = geoMercator().center(MAINLAND_CENTER).scale(MAINLAND_SCALE).translate([MAP_WIDTH / 2, MAP_HEIGHT / 2])
    this.okinawa = geoMercator().center(OKINAWA_CENTER).scale(Number(okinawaScale)).translate([Number(okinawaTx), Number(okinawaTy)])
    this.idleCaption = this.hasCaptionTarget ? this.captionTarget.textContent : ""

    // Turbo の snapshot から復元したときは、前に描いたピンが svg に残っている
    this.svgTarget.replaceChildren()
    JSON.parse(pins).forEach(pin => this.addPin(pin))
  }

  show({ params: { lat, lng, code, label } }) {
    this.hide()
    this.addPin({ lat, lng, code, active: true, temporary: true })
    if (this.hasCaptionTarget) this.captionTarget.textContent = label
  }

  hide() {
    this.svgTarget.querySelectorAll(".pin[data-temporary]").forEach(pin => pin.remove())
    if (this.hasCaptionTarget) this.captionTarget.textContent = this.idleCaption
  }

  addPin({ lat, lng, code, active, temporary }) {
    if (!lat || !lng) return

    const projection = String(code) === OKINAWA_CODE ? this.okinawa : this.mainland
    const [x, y] = projection([Number(lng), Number(lat)])
    const pin = document.createElementNS(NS, "g")
    pin.classList.add("pin")
    if (active) pin.classList.add("is-active")
    if (temporary) pin.dataset.temporary = ""
    pin.setAttribute("transform", `translate(${x.toFixed(1)} ${y.toFixed(1)})`)
    for (const name of ["pin-ring", "pin-core"]) {
      const circle = document.createElementNS(NS, "circle")
      circle.classList.add(name)
      circle.setAttribute("r", "6")
      pin.append(circle)
    }
    this.svgTarget.append(pin)
  }
}
